import { cva, type VariantProps } from 'class-variance-authority';

const statusIndicatorVariants = cva('rounded-full shadow', {
  variants: {
    size: {
      default: 'size-2',
      sm: 'size-1.5',
      xs: 'size-1',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

export interface StatusIndicatorProps
  extends React.ComponentProps<'div'>,
    VariantProps<typeof statusIndicatorVariants> {
  color: string;
}

export const StatusIndicator = ({
  size,
  color,
  className,
  ...rest
}: StatusIndicatorProps) => (
  <div
    aria-hidden
    className={statusIndicatorVariants({
      size,
      className,
    })}
    style={{
      backgroundColor: color,
      boxShadow: `0 0 4px 2px ${color}30`,
    }}
    {...rest}
  />
);
